/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import T from 'i18n-react';

import MetaTags from 'Components/MetaTags/MetaTags';
import PageComposer from 'Components/PageComposer/PageComposer';
import StaticPages from 'Components/StaticPages/StaticPages';
import texts from 'Components/texts.json';
import { PAGE_SLUGS } from 'Utilities/consts';

T.setTexts(texts);

export const ErrorPage = () => (
	<>
		<MetaTags noIndex description={T.translate('metaTags.description')} title={T.translate('metaTags.title')} />

		<PageComposer pageSlug={PAGE_SLUGS.STATIC_PAGE}>
			<StaticPages button={false} signUpSidebar={false} slug="error" />
		</PageComposer>
	</>
);

export default ErrorPage;
